<template>
    <div class="rule-table" data-qa="rule-table">
        <section class="rule-title" data-qa="rule-title">
            {{ $t('funnel.debug.rule') }}
        </section>

        <DsTableGrid
            ref="rulesRef"
            :data="rules"
            data-qa="rule-table-grid"
        >
            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.id')"
                prop="Id"
                width="80"
                data-qa="rule-table-column-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.rule.group.id')"
                prop="RuleGroupId"
                width="100"
                data-qa="rule-table-column-rule-group-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.order')"
                prop="Order"
                width="60"
                data-qa="rule-table-column-order"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.subject')"
                prop="Subject"
                width="120"
                data-qa="rule-table-column-subject"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.category')"
                prop="Category"
                width="140"
                data-qa="rule-table-column-category"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.field')"
                prop="Field"
                width="100"
                data-qa="rule-table-column-field"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.constraint')"
                prop="Constraint"
                width="120"
                data-qa="rule-table-column-constraint"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.comparison')"
                prop="Comparison"
                width="100"
                data-qa="rule-table-column-comparison"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.content.publishing.id')"
                prop="ContentPublishingId"
                width="160"
                data-qa="rule-table-column-content-publishing-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.date.created')"
                prop="DateCreated"
                width="100"
                data-qa="rule-table-column-date-created"
            />
        </DsTableGrid>
    </div>
</template>

<script>
export default {
    props: {
        rules: {
            type: Array,
            required: true,
        },
    },
};

</script>

<style lang="scss" scoped>
.rule-table {
    :deep(th .cell) {
        word-wrap: break-word;
        white-space: break-spaces;
    }

    .rule-title {
        font-weight: bold;
        margin: $spacing-250 0 $spacing-250 0;
    }
}
</style>
